module.exports = __webpack_public_path__ + "assets/img/recordIcon1.5cb7e4db.png";